import React from 'react'

import Input from '../../common/components/Input'
import {validateEmail} from '../../common/common'

const EmailInput = props => (
  <Input
    responsive
    type="email"
    name="email"
    autoComplete="email"
    maxLength="256"
    maxWidth={props.maxWidth}
    label="Email address"
    validate={validateEmail}
    onChange={props.onEmailChange}
    errorMsg={(!props.showPass && props.authError && props.authError.msg) || 'Please enter a valid email address'}
    value={props.email}
    error={props.authError && props.authError.status === "bad" && props.authError.msg}
    showPassedError={!props.showPass}
    required={props.required || true}
  />
)

export {EmailInput as default}



// WEBPACK FOOTER //
// ./assets/auth/components/EmailInput.js